<template>
  <div>
    <b-card class="shadow" style="background: linear-gradient(229deg, rgba(38,81,157,1) 0%, rgba(11,41,94,1) 83%);opacity: .90;">
      <b-card-text>
        <b-row class="align-items-center">
          <b-col md="6" class="px-5">
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu1.png"
                alt=""
            /></router-link>
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu2.png"
                alt=""
            /></router-link>
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu3.png"
                alt=""
            /></router-link>
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu4.png"
                alt=""
            /></router-link>
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu5.png"
                alt=""
            /></router-link>
            <router-link to="/laporan"
              ><img
                class="my-2"
                height="60px"
                src="/assets/images/report/menu6.png"
                alt=""
            /></router-link>
          </b-col>
          <b-col md="6">
            <img
              class="img-fluid"
              src="/assets/images/auth/auth-sidebar.png"
              alt=""
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>